import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Folder } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  folder: Identifiable<Folder>;
  retrievePrivateDocuments(
    req: Boundaries["retrievePrivateDocuments"]["request"],
  ): void;
}

function useRetrievePrivateDocuments(
  namespace: string,
  type: string,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrievePrivateDocumentsRequestPending(namespace, type),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrievePrivateDocumentsRequestSuccess(namespace, type),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrievePrivateDocumentsRequestFailure(namespace, type),
    ),
    folder: useSelector(() => selector.getPrivateDocuments(namespace, type)),
    retrievePrivateDocuments: core.retrievePrivateDocuments,
  };
}

export { useRetrievePrivateDocuments };
